/**
 * V70-S — 감사 대응 인사관리 화면 접근 판정 (메뉴 노출·라우트 가드의 단일 기준)
 *
 * 대상 화면: 인사관리 > 전사 근로 현황 / 연장 근무 관리
 * 허용: system_admin · role_admin_kr · KR 소속(users.companyCode='KR') role_hr
 * 차단: CN 관리자·CN 소속 HR·임원·조직장·팀장·일반 직원 등 그 밖의 역할
 *
 * - hr.employees.read / hr.manage 같은 범용 권한으로 판정하지 않는다 (rbac.hasRole 은 관리자급을
 *   모든 역할 보유로 간주하므로 사용하지 않고 실제 보유 역할만 본다).
 * - 서버 판정 SSoT 는 functions `modules/hr/hrKrAuditAccess.ts` (같은 규칙). 이 함수는 화면 표시용이다.
 * - 역할 로딩 전(roles 없음)에는 false.
 */
export const HR_COMPANY_WORK_STATUS_PATH = '/hr/company-work-status';
export const HR_OVERTIME_MANAGEMENT_PATH = '/hr/overtime-management';
export const HR_KR_AUDIT_PATHS: readonly string[] = [HR_COMPANY_WORK_STATUS_PATH, HR_OVERTIME_MANAGEMENT_PATH];

export function canAccessHrKrAudit(
  roles: readonly string[] | null | undefined,
  companyCode: string | null | undefined,
): boolean {
  if (!Array.isArray(roles)) return false;
  if (roles.includes('system_admin')) return true;
  if (roles.includes('role_admin_kr')) return true;
  if (roles.includes('role_admin_cn')) return false;
  return roles.includes('role_hr') && companyCode === 'KR';
}
